import $ from 'jquery'

export default function initMobileNavToggles () {
  $("html").addClass(navigator.platform.toLowerCase())
  // toggling web navigation top nav for mobile devices
  $('#toggleMobileNav').click(function() {
      $('#webNavigation').slideToggle('fast');
  })

  // side nav horizontal toggle for mobile
  $('#toggleMobileNavExternal').click(function() {
      var headerWidth = $('#header-content').width();
      var toggleAmount = '-'+headerWidth;
      var marginleft = $('#header-content').css('margin-left');
      if (marginleft !== '0px') {
          toggleAmount = '0px';
          $('#toggleMobileNavExternal .fa-bars').addClass('hidden');
          $('#toggleMobileNavExternal .fa-times').removeClass('hidden');
      } else {
          $('#toggleMobileNavExternal .fa-bars').removeClass('hidden');
          $('#toggleMobileNavExternal .fa-times').addClass('hidden');
      }
      $('#header-content').animate({ marginLeft: toggleAmount });
      resetOnResize();
  });

  function resetOnResize(){
    if($('#header-content').css('margin-left') !== '0px' && window.innerWidth < 896){
      window.onresize = function() {
        clearTimeout(window.resizedFinished);
        window.resizedFinished = setTimeout(function(){
          if (window.innerWidth >= 895) {
            var layoutDataElement = document.getElementById('js-layout')
            var layoutType = layoutDataElement 
              && layoutDataElement
              && layoutDataElement.datasetjsHsBuilderLayout
            if (layoutType == 'nav_side') {
              $('#header-content').animate({ marginLeft: '0px' }, 'fast');
            } else {
              $('#header-content').animate({ marginLeft: '-65%' }, 'fast');
              $('#toggleMobileNavExternal .fa-bars').removeClass('hidden');
              $('#toggleMobileNavExternal .fa-times').addClass('hidden');
            }
          }
        }, 250);
      }
    }
  }

  function hideSidenavToggle() {
    $("#sidenav_toggle").addClass('hidden');
    if($('body').hasClass('compact')){
      $("#sidenav_toggle i").removeClass('fa-chevron-left').addClass('fa-chevron-right');
    } else {
      $("#sidenav_toggle i").removeClass('fa-chevron-right').addClass('fa-chevron-left');
    }
  }

  var showSideNavToggle = setInterval(hideSidenavToggle, 1500);

  $('.logged-in.web-homescreen.nav-side #header-content').mouseenter(function(){
      clearInterval(showSideNavToggle);
      if($("#sidenav_toggle").hasClass('hidden')){
        $("#sidenav_toggle").removeClass('hidden');
      }
  }).mouseleave(function(){
      if(!$("#sidenav_toggle").hasClass('hidden')){
        showSideNavToggle = setInterval(hideSidenavToggle, 700);
      }
  })

  $('#navbarCollapse').mouseenter(function(){
      clearInterval(showSideNavToggle);
      if($("#sidenav_toggle").hasClass('hidden')){
        $("#sidenav_toggle").removeClass('hidden');
      }
  }).mouseleave(function(){
      if(!$("#sidenav_toggle").hasClass('hidden')){
        showSideNavToggle = setInterval(hideSidenavToggle, 700);
      }
  })

  
  // toggle on and off compact mode
  $('#sidenav_toggle').click(function() {
      if($('body').hasClass('compact')) {
        $('body').removeClass('compact');
        hideSidenavToggle();
        document.cookie ='efnavcompact=false';
      } else {
        $('body').addClass('compact');
        hideSidenavToggle();
        document.cookie ='efnavcompact=true';
      }
      $('.hs-banners-container .glide').addClass('update-glide');
      // a hack because resizesensor doesnt work in all browsers
  });    
}

